import React from "react"
import { getSource } from "../setting-utils"

const wrapperStyles = {
  display: "block",
  position: "relative",
  border: "none",
  width: "100%",
  height: "100%"
}

const ConditionalWrapper = ({ condition, wrapper, children }) =>
  condition ? wrapper(children) : <div style={wrapperStyles}>{children}</div>

export function Image({ data, properties }) {
  const { src, alt, url } = data.properties
  const crop = properties.crop || "none"
  const source = getSource(src, { crop })

  return (
    <ConditionalWrapper
      condition={url}
      wrapper={children => (
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          onClick={event => event.preventDefault()}
          style={wrapperStyles}
        >
          {children}
        </a>
      )}
    >
      {/* eslint-disable-next-line */}
      <img
        src={source}
        alt={alt}
        align="center"
        border="0"
        width="250"
        style={{
          width: "100%",
          height: "auto",
          objectFit: "cover",
          borderRadius: properties.radius,
          border: 0,
          display: "block",
          textDecoration: "none",
          msInterpolationMode: "bicubic",
          margin: "0 auto"
        }}
      />
    </ConditionalWrapper>
  )
}
